// у автора это books.js
import Vue from 'vue'

export default {
  state: {
    news: [],
    newsMaimPage: [],
    quillText: "",
    oldImages: undefined,
    // overlay: false,
    // overlayIMG: null,
  },
  mutations: {
    SET_NEWS(state, payload){
      state.news = payload
    },
    SET_NEWS_MAIN_PAGE(state, payload){
      state.newsMaimPage = payload
    },
    SET_QUILL_TEXT(state, payload){
      state.quillText = payload
    },
    DELETE_QUILL_TEXT(state){
      state.quillText = "";
    },
    SET_OLD_IMGES(state, payload){
      state.oldImages = payload;
    },
    DEL_OLD_IMGES(state){
      state.oldImages = undefined;
    }
    // SET_OVERlAY_LEVEL(state, payload){
    //   state.overlay = payload
    // },
    // SET_OVERlAY_IMAGE(state, payload){
    //   state.overlayIMG = payload
    // }
  },
  actions: {
    // загрузка питомцев из БД
    LOAD_NEWS({commit}) {
      // Vue.$db.collection("news").get()
      Vue.$db.collection("news").orderBy("timestamp", "desc").get()
      .then((querySnapshot) => {
        let news = []
        let newsMP = []
        querySnapshot.forEach(s=> {
          const data = s.data()
          // console.log(data);
          let info = {
            id: s.id,
            newsTitle: data.newsTitle,
            // description: data.description,
            images: data.images,
            mainImg: data.mainImg,
            imgIndexArr: data.imgIndexArr,
            emojiText: data.emojiText,
            userDate: data.userDate,
            timestamp: data.timestamp
          }
          news.push(info)
        });
// console.log(news);
        // Main page news array creation
        for (let index = 0; index <= 3; index++) {
          if (news[index] != undefined) {
            newsMP.push(news[index]);
          } 
        }
        
        // console.log(newsMP);
        commit('SET_NEWS_MAIN_PAGE', newsMP);
        commit('SET_NEWS', news)
      })
      .catch(error => console.log(error))
    },


    // load html text from Quill redactor
    UPDATE_QUILL_HTML({commit}, payload) {
      commit('SET_QUILL_TEXT', payload);
    },

    // DELETE html text from Quill redactor
    DELETE_QUILL_HTML({commit}) {
      commit('DELETE_QUILL_TEXT');
    },


    OLD_IMAGES({commit}, payload) {
      let db2 =  Vue.$db.collection("news").doc(payload);
      db2.get().then((doc) => {
        let oldImages = doc.data().images;
        commit('SET_OLD_IMGES', oldImages)
      }).catch((error) => {
        console.log("Error getting document:", error);
      });
    },

    DEL_OLD_IMAGES({commit}) {
        commit('DEL_OLD_IMGES')
    }
    
    // // Show overlay image in the news sector
    // SHOW_OVERLAY({commit}, {level, img}) {
    //  commit('SET_OVERlAY_LEVEL', level);
    //  commit('SET_OVERlAY_IMAGE', img);
    // }

  },
  getters: {
    getNews: (state) => state.news,
    getNewsMainPage: (state) => state.newsMaimPage,
    getQuillText: (state) => state.quillText,
    getOldImages: (state) => state.oldImages,
    // getOverlay: (state) => state.overlay,
    // getOverlayIMG: (state) => state.overlayIMG
  }
}